var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10.375,
    r: 10,
    fill: "#102262"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2,
    d: "M4.03 4.482h-.2l.12.16 4.73 6.324-4.753 5.135-.156.168h1.355l.03-.032 4.13-4.461 3.33 4.453.03.04h3.934l-.12-.16-4.999-6.683 4.42-4.776.156-.168h-1.355l-.03.032-3.796 4.102-3.062-4.094-.03-.04H4.03Zm9.116 10.79L5.822 5.479h1.442l7.324 9.793h-1.442Z"
  })));
};
export default SvgTwitter;